import { Modal, Box, useTheme } from "@mui/material";
import { PropsWithChildren } from "react";
import { TimesIcon } from "~components/Icons";

interface Props {
  isOpened: boolean;
  onClose: () => void;
}

const CustomModal = ({ isOpened, onClose, children }: PropsWithChildren<Props>) => {
  const theme: any = useTheme();
  const styles = {
    box: {
      borderRadius: "8px",
      backgroundColor: theme.palette.grey[900],
      position: "absolute" as "absolute",
      left: "50%",
      padding: "32px",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: "600px",
      maxHeight: "90vh",
      display: "flex",
      flexDirection: "column",
      overflowY: "auto" as "auto",
      overflowX: "hidden" as "hidden",

      "&::-webkit-scrollbar": {
        width: "10px",
      },

      "&::-webkit-scrollbar-thumb": {
        background: "#333",
        borderRadius: "16px",
        border: "1px solid #999999",
      },

      "&:focus": {
        outline: "none",
      },
    },

    closeButtonStyle: {
      alignItems: "center",
      backgroundColor: theme.palette.grey[700],
      borderRadius: "50%",
      cursor: "pointer",
      display: "flex",
      height: "36px",
      justifyContent: "center",
      position: "absolute" as "absolute",
      right: "10px",
      top: "10px",
      width: "36px",
      zIndex: 1,
    },
  };

  return (
    <Modal open={isOpened}>
      <Box sx={styles.box}>
        <div style={styles.closeButtonStyle} onClick={() => onClose()}>
          <TimesIcon />
        </div>
        {children}
      </Box>
    </Modal>
  );
};

export default CustomModal;
